export default screenConfigPrivate = {
  get: function(tutorMatching) {
    if (!(tutorMatching && tutorMatching.UiController)) return [];
    return [
      {
        id: 'zip',
        isInputScreen: true,
        inputScreen: {
          progress: '25%',
        },
      },  
      {
        id: 'subject',
        isInputScreen: true,
        inputScreen: {
          title: 'In welchem Fach?',
          progress: '50%',
        },
        onLoad: function() {
          if (document.querySelector('.footer .container')) {
            document.querySelector('.footer .container').classList.add('d-none');
          }
        }
      },
      {
        id: 'level',
        isInputScreen: true,
        inputScreen: {
          progress: '75%',
        },
      },{
        id: 'loader',
        isInputScreen: false,
        onLoad: function() {
          setTimeout(function() {
            
            tutorMatching.UiController.fetchResult();
          }, 750);
        }
      },{
        id: 'stacked-cards-block',
        isInputScreen: false,
        onLoad: function() {
          document.querySelector('.tutor-matching-container  .content').classList.remove('d-flex');
          document.querySelector('.tutor-matching-container .content').classList.add('narrow');
          window.stackedCards();
        }
      }
  ]}
};
